import { render, staticRenderFns } from "./RequestsEdit.vue?vue&type=template&id=5fb18dac&"
import script from "./RequestsEdit.vue?vue&type=script&lang=js&"
export * from "./RequestsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports